<template>
  <div class="user-profile-form">
    <Card class="no-head-border">
      <p slot="title"><b>Profile</b></p>
      <a href="#" slot="extra" @click.prevent="handleUpdateProfile('UserProfileForm')">
          <span v-if="isProfileSaving"> Saving </span>
          <span v-else> Save </span>
      </a>
      <Form ref="UserProfileForm" :model="formData" :rules="formRules" label-position="top">
        <Row :gutter="20">
          <i-col :xs="24" :sm="12">
            <FormItem label="First name" prop="first_name">
              <Input v-model="formData.first_name" class="k-input"/>
            </FormItem>
          </i-col>
          <i-col :xs="24" :sm="12">
            <FormItem label="Last name" prop="last_name">
              <Input v-model="formData.last_name" class="k-input"/>
            </FormItem>
          </i-col>
        </Row>
        <FormItem label="Company name" prop="company">
            <Input v-model="formData.company" class="k-input"/>
        </FormItem>
        <FormItem label="Email address" prop="email">
            <Input v-model="formData.email" class="k-input"/>
        </FormItem>
        <FormItem label="Phone number" prop="phone_number">
            <Input v-model="formData.phone_number" class="k-input"/>
        </FormItem>
      </Form>
      <Spin size="large" fix v-if="isProfileSaving"></Spin>
    </Card>
    <Card style="margin-top:20px;" class="no-head-border">
      <p slot="title"><b>Change Password</b></p>
      <UserPasswordForm />
    </Card>
  </div>
</template>

<script>
import { updateAccount } from '@/services/account'
import UserPasswordForm from './UserPasswordForm.vue'

export default {
  components: {
    UserPasswordForm
  },

  props: {
    userDetails: {
      type: Object,
      default: () => {},
      required: true
    }
  },

  data () {
    return {
      isProfileSaving: false,
      userType: localStorage.getItem('userType'),
      formData: {
        id: null,
        first_name: null,
        last_name: null,
        company: null,
        email: null,
        phone_number: null,
        avatar: ''
      },
      formRules: {
        first_name: [
          { required: true, message: 'The first name cannot be empty', trigger: 'blur' }
        ],
        last_name: [
          { required: true, message: 'The last name cannot be empty', trigger: 'blur' }
        ],
        company: [
          { required: true, message: 'The company cannot be empty', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Email cannot be empty', trigger: 'blur' },
          { type: 'email', message: 'Incorrect email format', trigger: 'blur' }
        ]
      }
    }
  },

  watch: {
    userDetails: {
      handler (data) {
        this.setFormData(data)
      },
      deep: true
    }
  },

  mounted () {
    this.setFormData(this.userDetails)
  },

  methods: {
    handleUpdateAccount () {
      this.isProfileSaving = true
      const userId = localStorage.getItem('_id')
      updateAccount(userId, this.formData).then(res => {
        this.isProfileSaving = false
        this.$Message.success('Account details updated successfully')
      }).catch(err => {
        console.log('Failed to update user account details: ', err)
        this.isProfileSaving = false
      })
    },

    handleUpdateProfile (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.handleUpdateAccount()
        } else {
          this.$Message.error('Fail!')
        }
      })
    },

    setFormData (data) {
      if (data) {
        this.formData = {
          id: data.id,
          first_name: data.first_name,
          last_name: data.last_name,
          company: data.company,
          email: data.email,
          phone_number: data.phone_number,
          avatar: (data.avatar_base64) ? data.avatar_base64 : ''
        }
      } else {
        this.formData = {
          id: null,
          first_name: null,
          last_name: null,
          company: null,
          email: null,
          phone_number: null,
          avatar: ''
        }
      }
    }
  }
}
</script>
